import Curation from './Curation.component';

export default Curation;